<template>
    <div style="z-index: 999999">
        <div class="modal hide fade" id="modalInventoryDetail" tabindex="0" role="dialog" aria-labelledby="modalInventoryDetail" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Inventory Setting</h4>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="vendor_no" class="col-sm-3 col-form-label text-left">Product</label>
                                    <div class="col-sm-9">
                                      <v-select :options="getProductList" :reduce="product => product.meta.code" label="product" v-model="setting.product_no" @input="setUomProduct"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                  <label for="amount" class="col-sm-3 col-form-label text-left">Unit Of Measure</label>
                                  <div class="col-sm-9">
                                    <select class="form-control" v-model="setting.uom_id">
                                      <option v-for="u in setting.uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="form-group row">
                                    <label for="vendor" class="col-sm-3 col-form-label text-left">Vendor</label>
                                    <div class="col-sm-9">
                                      <select class="form-control" v-model="setting.vendor_no">
                                        <option v-for="v in vendorList" :key="v.id" :value="v.vendor_no">{{ v.vendor_no }} - {{ v.name }}</option>
                                      </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="cost" class="col-sm-3 col-form-label text-left">Cost</label>
                                    <div class="col-sm-9">
                                      <input type="text" v-model="setting.cost" v-money="money" class="form-control" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="amount" class="col-sm-3 col-form-label text-left">Expired Date</label>
                                    <div class="col-sm-9">
                                        <datetime v-model="setting.expired_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-soft-primary" data-dismiss="modal" @click="save()">Save</button>
                        <button type="button" class="btn btn-hard-primary" >Clear</button>
                        <button type="button" class="btn btn-soft-outline-primary" data-dismiss="modal" >Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InventoryModal',
  props: ['setting'],
  data () {
    return {
      idDetail: 1,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      productList: state => state.products.productListAll,
      vendorList: state => state.vendors.vendorList
    }),
    getProductList: function () {
      var array = this.productList
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product: array[i].product_no + ' - ' + array[i].product_name,
          meta: {
            code: array[i].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    setUomProduct: function () {
      var product = this.productList.find(d => d.product_no === this.setting.product_no)
      if (product) {
        this.setting.uomList = product.uomList
      } else {
        this.setting.uomList = [{
          id: null,
          name: null
        }]
      }
    },
    selectProduct: function (value) {
      console.log(value)
    },
    save: function () {
      var pd = this.productList.find(d => d.product_no === this.setting.product_no)
      this.setting.product = pd.product_name
    },
    cancel: function () {
      console.log('cancel')
    }
  }
}
</script>
